import * as RadixDialog from '@radix-ui/react-dialog';

type ModalCloseProps = React.PropsWithChildren;

const ModalClose = ({ children }: ModalCloseProps) => <RadixDialog.Close asChild>{children}</RadixDialog.Close>;

export type { ModalCloseProps };
export { ModalClose };
